import { AppFileRouter } from 'src/interfaces/AppFileRouter';

export function getUploadAcceptConfig(endpoint: keyof AppFileRouter): Record<string, string[]> {
  switch (endpoint) {
    case 'image':
      return {
        'image/*': ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg'],
      };
    case 'document':
      return {
        'application/pdf': ['.pdf'],
        'application/msword': ['.doc'],
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
      };
    case 'trackMap':
      return {
        'application/xml': ['.xml'],
        'application/gpx+xml': ['.gpx'],
        'text/xml': ['.xml'],
      };
    default:
      return {};
  }
}
